export function buildRbBlockRoomName(sessionId: string, blockKey: string, subfield?: string | null): string {
  const base = `rb-block:${sessionId}:${blockKey}`;
  return subfield ? `${base}:${subfield}` : base;
}

const EDIT_ROLES = new Set(["owner", "advisor", "team_member", "solo_contributor"]);
const COMMENT_ROLES = new Set([...EDIT_ROLES, "comment"]);

export function proseEditableFromRole(role: string, isLocked: boolean): { canEdit: boolean; canComment: boolean } {
  return { canEdit: !isLocked && EDIT_ROLES.has(role), canComment: COMMENT_ROLES.has(role) };
}
